<template>
  <div data-qa="your-car-module">
    <section>
      <strong> {{ formatName(details.BrandName) }} {{ details.Trimline }} <br /> </strong>
      <div class="container">
        <div class="label">Exterieur kleur</div>
        <div class="value">{{ details.ExteriorColor }}</div>

        <div class="label">Interieur kleur</div>
        <div class="value">{{ details.InteriorColor }}</div>

        <div class="label">Chassisnummer</div>
        <div class="value">{{ details.Vin }}</div>

        <div v-if="displayFirstRegistrationWorld" class="label">Datum eerste toelating</div>
        <div v-if="displayFirstRegistrationWorld" class="value">
          {{ formatDate(details.FirstRegistrationWorld) }}
        </div>

        <div v-if="details.FirstRegistrationNL" class="label">
          Datum eerste tenaamstelling in NL
        </div>
        <div v-if="details.FirstRegistrationNL" class="value">
          {{ formatDate(details.FirstRegistrationNL) }}
        </div>

        <div v-if="details.Licenseplate1BRegistration" class="label">
          Datum laatste tenaamstelling
        </div>
        <div v-if="details.Licenseplate1BRegistration" class="value">
          {{ formatDate(details.Licenseplate1BRegistration) }}
        </div>

        <div v-if="details.MotExpiryDate" class="label">Vervaldatum APK</div>
        <div v-if="details.MotExpiryDate" class="value">
          {{ formatDate(details.MotExpiryDate) }}
        </div>
      </div>
    </section>
    <app-link
      v-if="!readOnly"
      :link="{ text: 'Inruilauto verwijderen' }"
      qa-hook="edit-license-plate-link"
      @click="clearLicensePlate"
    />
  </div>
</template>

<script>
import AppLink from '@/components/generic/presentational/atoms/appLink/AppLink.vue'
import moment from 'moment'

moment.locale('nl')

export default {
  name: 'CarDetails',
  components: {
    AppLink,
  },
  props: {
    details: {
      type: Object,
      default: () => {},
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['updateLicensePlate'],
  computed: {
    displayFirstRegistrationWorld() {
      return (
        this.details.FirstRegistrationWorld &&
        this.details.FirstRegistrationWorld !== this.details.FirstRegistrationNL
      )
    },
  },

  methods: {
    clearLicensePlate() {
      this.$emit('updateLicensePlate', '')
    },
    formatDate(value) {
      return value == null ? '' : moment(value).format('DD-MM-YYYY')
    },
    formatName(value) {
      if (!value) return ''
      value = value.toString().toLowerCase()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5px;
  font-size: $font-size-base * 0.75;
}
</style>
